/* CONSENT COOKIES GDPR */
import { cookieStorage, loadJs, log } from './utilities'
import {TCModel, TCString, Vector} from '@iabtechlabtcf/core';
import cmpstub from '@iabtechlabtcf/stub';

const EVENTS = {
    FUNDINGCHOICES_LOADED: 'mega.fundingchoices.loaded',
	CONSENT_READY: 'mega.consent.ready',
	CONSENT_LOADED: 'mega.consent.loaded',
	CONSENT_NOTLOADED: 'mega.consent.notloaded',
	CONSENT_SETTINGS: 'mega.consent.settings',
	ADBLOCKER_ENABLED: 'mega.adblocker.enabled',
	ADBLOCKER_DISABLED: 'mega.adblocker.disabled',
	ADBLOCKER_UNKNOWN: 'mega.adblocker.unknown',
}
export { EVENTS }

const fundingChoicesUrl = 'https://fundingchoicesmessages.google.com/i/4045?ers=3'

const cookies = cookieStorage()
const COOKIE_GDPR_CONSENTSTRING: string = 'mega_gdpr_consentstring'

let _consentInitialized: boolean = false

let _consentString: string = ''
let _purposes: boolean[] = []
let _specialFeatureOptins: boolean[] = []

export async function load(config: PublisherConfig):Promise<Consent|null> {

    if (!window.__tcfapi && config.customConsent) {
        cmpstub()
    }

    return new Promise( (resolve):void => {
        window.googlefc = window.googlefc || {}
        window.googlefc.ccpa = window.googlefc.ccpa || {}
        window.googlefc.callbackQueue = window.googlefc.callbackQueue || []

        window.addEventListener(EVENTS.CONSENT_SETTINGS, () => {
            if (window.googlefc.showRevocationMessage) window.googlefc.showRevocationMessage()
        })

        window.addEventListener(EVENTS.CONSENT_LOADED, () => {
            log('---- CONSENT LOADED EVENT ----')
            const _tmpConsent = getConsent()

            //setcookie
            cookies.set(COOKIE_GDPR_CONSENTSTRING, _tmpConsent._consentString, 1)

            resolve(_tmpConsent)
        })

        window.addEventListener(EVENTS.CONSENT_NOTLOADED, () => {

            //remove cookie
            cookies.set(COOKIE_GDPR_CONSENTSTRING, "", -10)

            resolve(null)
        })

        window.googlefc.callbackQueue.push({
            'CONSENT_DATA_READY': () => {
                log('---- IAB CONSENT DATA READY ----')
                

                window.__tcfapi('addEventListener', 2, (tcData, success) => {
                    if (success) {
                        log('---- IAB HAS CONSENT1 ----')
                        
                        _consentString = tcData.tcString
                        _purposes = tcData.purpose.consents
                        _specialFeatureOptins = tcData.specialFeatureOptins
                        
                        dispatchEvent(new CustomEvent(EVENTS.CONSENT_READY))

                        _consentInitialized = true

                        if (tcData.eventStatus === 'tcloaded') {
                            // remove event listener when consent string has loaded
                            window.__tcfapi('removeEventListener', 2, (success) => {
                                //console.log('removed event listener: ' + tcData.listenerId);
                            }, tcData.listenerId);
                        }
                        

                        dispatchEvent(new CustomEvent(EVENTS.CONSENT_LOADED))

                        resolve(getConsent())

                    } else {
                        dispatchEvent(new CustomEvent(EVENTS.CONSENT_NOTLOADED))
                        resolve(null)
                    }
                })
            }
        })

        if (window.__tcfapi) {
            window.__tcfapi('addEventListener', 2, (tcData, success) => {
                if (success) {
                    log('---- IAB HAS CONSENT READY ----')
                    
                    _consentString = tcData.tcString
                    _purposes = tcData.purpose.consents
                    _specialFeatureOptins = tcData.specialFeatureOptins
                    
                    dispatchEvent(new CustomEvent(EVENTS.CONSENT_READY))

                    _consentInitialized = true

                    if (tcData.eventStatus === 'tcloaded') {
                        // remove event listener when consent string has loaded
                        window.__tcfapi('removeEventListener', 2, (success) => {
                            //console.log('removed event listener: ' + tcData.listenerId);
                        }, tcData.listenerId);
                    }
                    

                    dispatchEvent(new CustomEvent(EVENTS.CONSENT_LOADED))

                    resolve(getConsent())

                } else {
                    dispatchEvent(new CustomEvent(EVENTS.CONSENT_NOTLOADED))
                    resolve(null)
                }
            })
        }
        

        window.googlefc.callbackQueue.push({
            'AD_BLOCK_DATA_READY':
            () => {
                switch (window.googlefc.getAdBlockerStatus()) {
                    case window.googlefc.AdBlockerStatusEnum.EXTENSION_LEVEL_AD_BLOCKER:
                    case window.googlefc.AdBlockerStatusEnum.NETWORK_LEVEL_AD_BLOCKER:
                        // Insert handling for cases where the user is blocking ads.
                        dispatchEvent(new CustomEvent(EVENTS.ADBLOCKER_ENABLED))
                        break;
                    case window.googlefc.AdBlockerStatusEnum.NO_AD_BLOCKER:
                        // Insert handling for cases where the user is not blocking ads.
                        dispatchEvent(new CustomEvent(EVENTS.ADBLOCKER_DISABLED))
                        break;
                    case window.googlefc.AdBlockerStatusEnum.UNKNOWN:
                        // Insert handling for unknown cases.
                        dispatchEvent(new CustomEvent(EVENTS.ADBLOCKER_UNKNOWN))
                        break;
                }
            }
        })
        
        // first check for consent cookie to load extra fast without loading fundingchoices first, if not > load fundingChoices
        if (!hasConsent() && !config.customConsent) {
            //log('---- !hasConsent, try to load fundingchoices ----')
            loadJs(fundingChoicesUrl, () => { dispatchEvent(new CustomEvent(EVENTS.FUNDINGCHOICES_LOADED)) }, ()=>{ resolve(null) })
        } else {
            //fundingchoices will be loaded by GPT script, that should be in the callback now
            resolve(getConsent())
        }
        

    })

}

export function hasConsent() {
    log('---- MEGA HAS CONSENT? ----');
    if (cookies.has(COOKIE_GDPR_CONSENTSTRING)) {
        let consentString = cookies.get(COOKIE_GDPR_CONSENTSTRING)

        consentString = consentString.indexOf('D') == 0 ? ('C'+consentString.substring(1)) : consentString

        log('---- MEGA CONSENT FROM COOKIE ----');
        log(consentString);

        const decodedTCModel: TCModel = TCString.decode(consentString)
        
        _consentString = consentString
        
        _purposes = []
        decodedTCModel.purposeConsents.forEach((val:boolean,key:number)=>{
            _purposes[key] = val
        })

        _specialFeatureOptins = []
        decodedTCModel.specialFeatureOptins.forEach((val:boolean,key:number)=>{
            _specialFeatureOptins[key] = val
        })

        dispatchEvent(new CustomEvent(EVENTS.CONSENT_LOADED))
        
        return true
    } 
    return false
}

export function getConsent(): Consent {

    _consentString = _consentString.indexOf('D') == 0 ? ('C'+_consentString.substring(1)) : _consentString

    return {
        _consentString,
        _purposes,
        _specialFeatureOptins
    }
}


